module.exports = __webpack_public_path__ + "img/ico-expand-brand-color.bdb7d0fa.svg";